import { render, staticRenderFns } from "./CircleElementPublish.vue?vue&type=template&id=89d2f5ba&"
import script from "./CircleElementPublish.vue?vue&type=script&lang=ts&"
export * from "./CircleElementPublish.vue?vue&type=script&lang=ts&"
import style0 from "./CircleElementPublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports